import { ApplicationFileType } from '../enums';
import { ApplicationFile } from './application-file';
import { PartnerLightData } from './partner-light-data';
import { environment } from '../../../environment/environment';

export interface Partner extends PartnerLightData {
  id: string;
  name: string;
  contactEmail: string;
  logo: ApplicationFile;
}

export namespace Partner {
  export function mapFromApiValue({ logo, ...restOfPartner }: any): Partner {
    return {
      ...restOfPartner,
      logo: logo && ApplicationFile.mapFromApiValue(logo),
    };
  }
}

export const DEMO_PARTNER: Partner = {
  id: '-1',
  name: 'Demo Partner',
  contactEmail: 'demo@' + environment.rootUrl,
  logo: {
    id: '-1',
    name: 'logo.png',
    size: 0,
    type: ApplicationFileType.PartnerLogo,
  },
};
